import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {RedirectResponse} from './contracts'

export async function apiCancelMigration(): Promise<RedirectResponse> {
  const apiMetadata = getApiMetadata('memex-migration-cancel-api-data')
  const {data} = await fetchJSON<RedirectResponse>(apiMetadata.url, {
    method: 'DELETE',
    token: apiMetadata.token,
  })

  return data
}
